import styled from 'styled-components'
import { maxQuery } from '../../../helpers'

export default styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  header {
    margin-bottom: 2em;

    .top--row {
      h2 {
        color: #fff;
        font-size: 1.5rem;
        font-weight: 600;
        margin: 0 0 0.25em 0;
      }

      .subtitle {
        color: rgba(255, 255, 255, 0.6);
        font-size: 0.9rem;
        margin: 0 0 1em 0;
      }
    }

    .header--row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 1rem;
      flex-wrap: wrap;

      .filters {
        display: flex;
        gap: 1rem;
        flex: 1;

        ${maxQuery('md')} {
          flex-direction: column;
          width: 100%;
        }
      }

      .filter-select,
      .search-input {
        padding: 0.75em 1em;
        background: #272B4A;
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 8px;
        color: #fff;
        font-size: 0.95rem;

        &::placeholder {
          color: rgba(255, 255, 255, 0.5);
        }

        &:focus {
          outline: none;
          border-color: ${({ theme }) => theme.primary};
        }
      }

      .filter-select {
        min-width: 150px;
      }

      .search-input {
        flex: 1;
        min-width: 250px;
      }

      .add--btn {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.75em 1.5em;
        background: ${({ theme }) => theme.primary};
        color: #fff;
        border: none;
        border-radius: 8px;
        font-weight: 500;
        cursor: pointer;
        transition: opacity 0.2s;

        &:hover {
          opacity: 0.9;
        }
      }
    }
  }

  .content--container {
    background: #272B4A;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    padding: 2em;
    flex: 1;
    display: flex;
    flex-direction: column;

    .empty--container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 4em 2em;
      text-align: center;
      flex: 1;
      min-height: 400px;

      svg {
        margin-bottom: 1em;
        opacity: 0.3;
      }

      h3 {
        font-size: 1.5rem;
        color: rgba(255, 255, 255, 0.9);
        margin: 0.5em 0;
        font-weight: 600;
      }

      .instruction {
        color: rgba(255, 255, 255, 0.6);
        margin-bottom: 2em;
        font-size: 1rem;
        max-width: 400px;
      }

      .add--btn {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.75em 1.5em;
        background: ${({ theme }) => theme.primary};
        color: #fff;
        border: none;
        border-radius: 8px;
        font-weight: 500;
        cursor: pointer;
        transition: opacity 0.2s;
        font-size: 1rem;

        &:hover {
          opacity: 0.9;
        }
      }
    }

    .orders--list {
      display: flex;
      flex-direction: column;
      gap: 1em;
    }

    .orders--grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
      gap: 1.5em;

      ${maxQuery('md')} {
        grid-template-columns: 1fr;
      }
    }
  }
`
